import styled from "@emotion/styled";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: ${({ size }) => (size === "sm" ? "36px" : "48px")};
  padding: 0 ${({ size }) => (size === "sm" ? "12px" : "20px")};
  border-radius: ${({ shape }) => (shape === "pill" ? "999px" : "8px")};
  border: 1px solid transparent;
  font-size: ${({ size }) => (size === "sm" ? "13px" : "15px")};
  font-weight: 500;
  width: ${({ block }) => (block ? "100%" : "auto")};

  background: ${({ variant }) =>
    variant === "ghost"
      ? "transparent"
      : variant === "outline"
      ? "#ffffff"
      : variant === "danger"
      ? "#fb4d44"
      : "#003580"};
  color: ${({ variant }) =>
    variant === "outline"
      ? "#222222"
      : variant === "ghost"
      ? "#003580"
      : "#ffffff"};
  border-color: ${({ variant }) =>
    variant === "outline"
      ? "#d9dde2"
      : variant === "ghost"
      ? "transparent"
      : "transparent"};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }
`;

export default Button;
